var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Collection, Property } from '@syncfusion/ej2-base';
import { RibbonItem } from './ribbon-item';
/**
 * Defines the items of Ribbon.
 */
export class RibbonCollection extends ChildProperty {
    /**
     * @param {Object} prop - Gets the property of collection.
     * @param {boolean} muteOnChange - Gets the boolean value of muteOnChange.
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        super.setProperties(prop, muteOnChange);
    }
}
__decorate([
    Property('')
], RibbonCollection.prototype, "id", void 0);
__decorate([
    Property('')
], RibbonCollection.prototype, "cssClass", void 0);
__decorate([
    Collection([], RibbonItem)
], RibbonCollection.prototype, "items", void 0);
